import React from "react";
import { Link } from "react-router-dom";
import "./Join.css";
import Footer from '../Footer';

function Join() {
  return (
    <>
    <div>
      <h1 className="join-header" id="titleroundedbox">Join Our Team!</h1>
      <div className="join-container">
        <div className="content">
          <div className="headerbox"></div>

          <p className="join-subheader">
            We are always looking for promising students! <br /><br />
            Undergraduate / Graduate / Post-Doc students are welcome. If interested, please send an email to{" "}
            <a href="mailto:happy1@utexas.edu">happy1@utexas.edu</a>
          </p>
          <br />

          <div className="join-subheader info">
            <p>Please include the following in your email:</p>
            <br />
            <ul className="contentlist">
              <li>Year of Study</li>
              <li>Degree Program</li>
              <li>CV/Resume</li>
              <li>What you are looking for (Research, Potential Grad Student, For-credit undergrad topic, etc.)</li>
            </ul>
          </div>

          <br />
          <h1>
            Internship Opportunities{" "}
            <span style={{ color: "#ff6b6b", fontSize: "0.6em" }}>(NEW – Posted on 05/29/2025)</span>
          </h1>
          <p className="join-subheader">
            We are currently offering a focused, remote summer internship opportunity at the TExUS Lab. Ideal for
            students with a strong background in meteorology and climate modeling. <br />
            <Link to="/internship">Click here for details →</Link>
          </p>
        </div>

        <div className="img-container">
          <img
            src="https://texuslab.org/images/Umbrella.jpeg"
            alt="Promising Students"
            className="header-image"
          />
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default Join;
